export enum TicketPropertyTypes {
    CASENUMBER = 'CASENUMBER',
}
